import { createSelector } from "reselect";
import ReduxState from "../models";

export const getProperty = (state: ReduxState) => state.property;

export const getPropertyType = createSelector(getProperty, property => property.type);
